import {Routes} from "@angular/router";
import {HomeComponent} from "./components/home/home.component";
import {LoginComponent} from "./components/login/login.component";
import {DynamicPageComponent} from "./components/dynamic-page/dynamic-page.component";
import { AppProfileComponent } from './components/app-profile/app-profile.component';
import {ResetPasswordComponent} from "./components/user/reset-password/reset-password.component";
import {ForgotPasswordComponent} from "./components/user/forgot-password/forgot-password.component";
import {RFQComponent} from "./components/buyer/rfq/rfq.component";
import {BusinessUserSignupComponent} from "./components/sign-up";
import {PageNotFoundComponent} from "./components/page-not-found/page-not-found.component";
import {OnebillCheckoutComponent} from "./components/buyer/onebill-checkout/onebill-checkout.component";


export const rootRouterConfig: Routes = [
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {path: 'home', component: HomeComponent},
  {path: 'profile/:id/:name', component: AppProfileComponent},
  {path: 'login', component: LoginComponent},
  {path: 'signup', component: BusinessUserSignupComponent},
  {path: 'info/:id', component: DynamicPageComponent},
  {path: 'request-for-quotation', component: RFQComponent},
  {path: 'reset-password', component: ResetPasswordComponent},
  {path: 'forgot-password', component: ForgotPasswordComponent},
  {path: 'onebill-checkout', component: OnebillCheckoutComponent},
  { path: '**', component: PageNotFoundComponent },
];





// WEBPACK FOOTER //
// ./src/app/app.routes.ts